import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    description: string;
    restrictedDescription: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toggle title for making a project restricted */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAccessSwitch.title?c=rh3djn0viyad", defaultMessage: "Make Restricted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for unrestricted project access */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAccessSwitch.description?c=14uq6uar4803l", defaultMessage: "Only people directly invited to the project will have access." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description when the project is already restricted */
            restrictedDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAccessSwitch.restrictedDescription?c=w65yojp8gnmq", defaultMessage: "Only people directly invited to the project can access." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
